// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_commentsHeader__WH6b1 {
  display: flex;
  align-items: center;
  gap: 0.75rem; }

.styles_countButton__ivWg0 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: opacity 0.2s ease; }
  .styles_countButton__ivWg0:hover:not(:disabled) {
    opacity: 0.7; }
  .styles_countButton__ivWg0:disabled {
    cursor: default; }

.styles_countText__FKTCo {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500; }

.styles_actionButton__55dvZ {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease; }
  .styles_actionButton__55dvZ:hover {
    background-color: rgba(0, 0, 0, 0.05); }
  .styles_actionButton__55dvZ:active {
    background-color: rgba(0, 0, 0, 0.1); }

.styles_actionIcon__ONB6x {
  font-size: 1.125rem;
  line-height: 1; }

.styles_commentsModal__iX8Ei {
  max-width: 37.5rem;
  width: 90vw;
  max-height: 70vh;
  overflow: hidden;
  display: flex;
  flex-direction: column; }

.styles_commentsModalList__WMtQA {
  flex: 1 1;
  overflow-y: auto;
  padding: 1rem 0; }
  .styles_commentsModalList__WMtQA .styles_commentItem__ylnK5 {
    margin: 0.5rem 1rem; }
    .styles_commentsModalList__WMtQA .styles_commentItem__ylnK5:last-child {
      margin-bottom: 0; }

.styles_commentItem__ylnK5 {
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 0.5rem;
  border: 0.0625rem solid #8080801a;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease; }
  .styles_commentItem__ylnK5:hover {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08); }
  .styles_commentItem__ylnK5:last-child {
    margin-bottom: 0; }

.styles_commentAuthor__W7buo {
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8);
  margin-right: 0.5rem; }

@media (max-width: 48rem) {
  .styles_commentsHeader__WH6b1 {
    gap: 0.5rem; }
  .styles_commentItem__ylnK5 {
    padding: 0.625rem; }
  .styles_countText__FKTCo {
    font-size: 0.8125rem; }
  .styles_actionIcon__ONB6x {
    font-size: 1rem; } }

.styles_commentsModalHeader__5qIEN {
  margin-bottom: 1rem;
  opacity: 0.5; }
  .styles_commentsModalHeader__5qIEN h2 {
    color: #808080e6; }

.styles_commentsModalFooter__yMu4k {
  margin: 1rem; }
  .styles_commentsModalFooter__yMu4k button {
    opacity: 0.5;
    border: 1px dashed #80808080;
    height: 100%;
    width: 100%; }
`, "",{"version":3,"sources":["webpack://./src/modules/teachings/components/TeachingCommentsSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAOA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,6BAA6B,EAAA;EAL/B;IAQI,YAAY,EAAA;EARhB;IAYI,eAAe,EAAA;;AAInB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC,EAAA;EATxC;IAYI,qCAAqC,EAAA;EAZzC;IAgBI,oCAAoC,EAAA;;AAIxC;EACE,mBAAmB;EACnB,cAAc,EAAA;;AAIhB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAA;;AAGxB;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe,EAAA;EAHjB;IAMI,mBAAmB,EAAA;IANvB;MASM,gBAAgB,EAAA;;AAMtB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,qBAAqB;EACrB,iCC9EgB;ED+EhB,oDAAoD;EACpD,gCAAgC,EAAA;EAPlC;IAUI,kDAAkD,EAAA;EAVtD;IAcI,gBAAgB,EAAA;;AAIpB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB,EAAA;;AAItB;EACE;IACE,WAAW,EAAA;EAGb;IACE,iBAAiB,EAAA;EAGnB;IACE,oBAAoB,EAAA;EAGtB;IACE,eAAe,EAAA,EAChB;;AAGH;EACE,mBAAmB;EACnB,YAAY,EAAA;EAFd;IAKI,gBCnHc,EAAA;;ADuHlB;EACE,YAAY,EAAA;EADd;IAII,YAAY;IACZ,4BC/Hc;IDgId,YAAY;IACZ,WAAW,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n// Comments Section Styles\n.commentsSection {\n  // No specific styles needed - will inherit from parent\n}\n\n.commentsHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.countButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n\n  &:hover:not(:disabled) {\n    opacity: 0.7;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.countText {\n  font-size: 0.875rem;\n  color: rgba(0, 0, 0, 0.6);\n  font-weight: 500;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n\n.actionIcon {\n  font-size: 1.125rem;\n  line-height: 1;\n}\n\n// Comments Modal Styles\n.commentsModal {\n  max-width: 37.5rem;\n  width: 90vw;\n  max-height: 70vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.commentsModalList {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1rem 0;\n\n  .commentItem {\n    margin: 0.5rem 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n// Individual Comment Styles\n.commentItem {\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  background-color: rgba(0, 0, 0, 0.02);\n  border-radius: 0.5rem;\n  border: 0.0625rem solid $grey10;\n  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.2s ease;\n\n  &:hover {\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08);\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.commentAuthor {\n  font-weight: 700;\n  color: rgba(0, 0, 0, 0.8);\n  margin-right: 0.5rem;\n}\n\n// Responsive adjustments\n@media (max-width: 48rem) {\n  .commentsHeader {\n    gap: 0.5rem;\n  }\n\n  .commentItem {\n    padding: 0.625rem;\n  }\n\n  .countText {\n    font-size: 0.8125rem;\n  }\n\n  .actionIcon {\n    font-size: 1rem;\n  }\n}\n\n.commentsModalHeader {\n  margin-bottom: 1rem;\n  opacity: 0.5;\n\n  h2 {\n    color: $grey90;\n  }\n}\n\n.commentsModalFooter {\n  margin: 1rem;\n\n  & button {\n    opacity: 0.5;\n    border: 1px dashed $grey50;\n    height: 100%;\n    width: 100%;\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commentsHeader": `styles_commentsHeader__WH6b1`,
	"countButton": `styles_countButton__ivWg0`,
	"countText": `styles_countText__FKTCo`,
	"actionButton": `styles_actionButton__55dvZ`,
	"actionIcon": `styles_actionIcon__ONB6x`,
	"commentsModal": `styles_commentsModal__iX8Ei`,
	"commentsModalList": `styles_commentsModalList__WMtQA`,
	"commentItem": `styles_commentItem__ylnK5`,
	"commentAuthor": `styles_commentAuthor__W7buo`,
	"commentsModalHeader": `styles_commentsModalHeader__5qIEN`,
	"commentsModalFooter": `styles_commentsModalFooter__yMu4k`
};
export default ___CSS_LOADER_EXPORT___;
